export var ELoggerSeverity;
(function (ELoggerSeverity) {
    ELoggerSeverity[ELoggerSeverity["CRITICAL"] = 0] = "CRITICAL";
    ELoggerSeverity[ELoggerSeverity["ANALYSIS"] = 1] = "ANALYSIS";
    ELoggerSeverity[ELoggerSeverity["DEVELOPMENT"] = 2] = "DEVELOPMENT";
    ELoggerSeverity[ELoggerSeverity["COUPONS"] = 3] = "COUPONS";
    ELoggerSeverity[ELoggerSeverity["SELF_SERVICE_SYNC_SUMMARY"] = 4] = "SELF_SERVICE_SYNC_SUMMARY";
    ELoggerSeverity[ELoggerSeverity["CLICKON_ORDER"] = 5] = "CLICKON_ORDER";
})(ELoggerSeverity || (ELoggerSeverity = {}));
export var Environment;
(function (Environment) {
    Environment["DEV"] = "dev";
    Environment["STAGE"] = "stage";
    Environment["PROD"] = "prod";
    Environment["NO_ENV"] = "";
})(Environment || (Environment = {}));
export var DeviceType;
(function (DeviceType) {
    DeviceType["Desktop"] = "desktop";
    DeviceType["Mobile"] = "mobile";
})(DeviceType || (DeviceType = {}));
export var Platform;
(function (Platform) {
    Platform["Desktop"] = "Desktop";
    Platform["MobileWeb"] = "Mobile Web";
    Platform["AppIos"] = "App iOS";
    Platform["AppAndroid"] = "App Android";
})(Platform || (Platform = {}));
export var ECategory;
(function (ECategory) {
    ECategory["FLIGHTS"] = "Flights";
    ECategory["DOMESTIC"] = "Domestic";
    ECategory["SHOWS"] = "Shows";
    ECategory["PACKAGES"] = "Packages";
})(ECategory || (ECategory = {}));
export var HttpMethod;
(function (HttpMethod) {
    HttpMethod["GET"] = "GET";
    HttpMethod["POST"] = "POST";
    HttpMethod["PUT"] = "PUT";
})(HttpMethod || (HttpMethod = {}));
export var ContentTypes;
(function (ContentTypes) {
    ContentTypes["JSON"] = "JSON";
    ContentTypes["XML"] = "XML";
    ContentTypes["TEXT"] = "TEXT";
    ContentTypes["RESPONSE_JSON"] = "RESPONSE_JSON";
    ContentTypes["URLENCODED"] = "x-www-form-urlencoded";
})(ContentTypes || (ContentTypes = {}));
export var EUserJourneyType;
(function (EUserJourneyType) {
    EUserJourneyType["FLIGHTS"] = "FLIGHTS";
    EUserJourneyType["DOMESTIC"] = "DOMESTIC";
    EUserJourneyType["SHOWS"] = "SHOWS";
})(EUserJourneyType || (EUserJourneyType = {}));
export var ELastUpdateStatusCatalogProduct;
(function (ELastUpdateStatusCatalogProduct) {
    ELastUpdateStatusCatalogProduct["Agent"] = "agent";
    ELastUpdateStatusCatalogProduct["System"] = "system";
    ELastUpdateStatusCatalogProduct["DeactivateSystemRules"] = "DeactivateSystemRules";
})(ELastUpdateStatusCatalogProduct || (ELastUpdateStatusCatalogProduct = {}));
export var EAppConfigFieldType;
(function (EAppConfigFieldType) {
    EAppConfigFieldType["Categories"] = "categories";
    EAppConfigFieldType["AppVersion"] = "appVersion";
    EAppConfigFieldType["GlobalPopup"] = "globalPopup";
    EAppConfigFieldType["Payments"] = "payments";
    EAppConfigFieldType["Configs"] = "configs";
})(EAppConfigFieldType || (EAppConfigFieldType = {}));
export const APP_CONFIG_PATHS = {
    popups: '/dynamic/client/popups-config.json',
};
export var EAppGlobalPopupType;
(function (EAppGlobalPopupType) {
    EAppGlobalPopupType["ShowOnce"] = "ShowOnce";
    EAppGlobalPopupType["ShowAlways"] = "ShowAlways";
})(EAppGlobalPopupType || (EAppGlobalPopupType = {}));
export var ICatalogItemType;
(function (ICatalogItemType) {
    ICatalogItemType["Default"] = "default";
})(ICatalogItemType || (ICatalogItemType = {}));
export var EFlightCatalogContentType;
(function (EFlightCatalogContentType) {
    EFlightCatalogContentType["RoundTripV2"] = "RoundTripV2";
    EFlightCatalogContentType["OneWay"] = "OneWay";
    EFlightCatalogContentType["FlightsToIsrael"] = "FlightsToIsrael";
    EFlightCatalogContentType["OneWayBundle"] = "OneWayBundle";
    EFlightCatalogContentType["Carousel"] = "Carousel";
    EFlightCatalogContentType["Packages"] = "Packages";
    EFlightCatalogContentType["PackagesNew"] = "PackagesNew";
    EFlightCatalogContentType["MarketingBanners"] = "MarketingBanners";
})(EFlightCatalogContentType || (EFlightCatalogContentType = {}));
export var EClientFlightDealType;
(function (EClientFlightDealType) {
    EClientFlightDealType["RoundTrip"] = "RoundTrip";
    EClientFlightDealType["OneWay"] = "OneWay";
    EClientFlightDealType["Packages"] = "Packages";
    EClientFlightDealType["OneWayBundle"] = "OneWayBundle";
})(EClientFlightDealType || (EClientFlightDealType = {}));
export var EAncillaryServiceModuleType;
(function (EAncillaryServiceModuleType) {
    EAncillaryServiceModuleType["RoundTrip"] = "RoundTrip";
    EAncillaryServiceModuleType["OneWay"] = "OneWay";
    EAncillaryServiceModuleType["Packages"] = "Packages";
    EAncillaryServiceModuleType["OneWayBundle"] = "OneWayBundle";
})(EAncillaryServiceModuleType || (EAncillaryServiceModuleType = {}));
export var ECarouselCategory;
(function (ECarouselCategory) {
    ECarouselCategory["FLIGHTS_AND_PACKAGES"] = "FlightsAndPackages";
    ECarouselCategory["DOMESTIC"] = "Domestic";
    ECarouselCategory["SHOWS"] = "Shows";
})(ECarouselCategory || (ECarouselCategory = {}));
export var ECarouselSubCategory;
(function (ECarouselSubCategory) {
    ECarouselSubCategory["ALL"] = "All";
    ECarouselSubCategory["ROUND_TRIP"] = "RoundTrip";
    ECarouselSubCategory["VACATION_PACKAGES"] = "VacationPackages";
    ECarouselSubCategory["RETURN_DIFFERENT_DEST"] = "ReturnDifferentDest";
    ECarouselSubCategory["ONE_WAY"] = "OneWay";
    ECarouselSubCategory["ORGANIZED_TOURS"] = "OrganizedTours";
    ECarouselSubCategory["CRUISES"] = "Cruises";
    ECarouselSubCategory["SPORT_PACKAGE"] = "SportPackage";
    ECarouselSubCategory["SKI_PACKAGE"] = "SkiPackage";
    ECarouselSubCategory["PACKAGE_KOSHER"] = "PackageKosher";
    ECarouselSubCategory["PACKAGE_EVENT"] = "EventPackage";
    ECarouselSubCategory["SUMMER_DEALS"] = "SummerDeals";
    ECarouselSubCategory["REGULAR"] = "Regular";
    ECarouselSubCategory["SPA_PACKAGE"] = "SpaPackage";
    ECarouselSubCategory["DOMESTIC_SHOWS_PACKAGE"] = "DomesticShowsPackage";
    ECarouselSubCategory["DOMESTIC_FAMILY_PACKAGE"] = "DomesticFamilyPackage";
    ECarouselSubCategory["DOMESTIC_KOSHER_PACKAGE"] = "DomesticKosherPackage";
    ECarouselSubCategory["INDEPENDENCE_DAY"] = "IndependenceDay";
    ECarouselSubCategory["SHAVUOT"] = "Shavuot";
    ECarouselSubCategory["THEATER"] = "Theater";
    ECarouselSubCategory["STANDUP"] = "Standup";
    ECarouselSubCategory["KIDS"] = "Kids";
    ECarouselSubCategory["MUSIC"] = "Music";
    ECarouselSubCategory["CINEMA"] = "Cinema";
    ECarouselSubCategory["LECTURES"] = "Lectures";
    ECarouselSubCategory["DANCE"] = "Dance";
    ECarouselSubCategory["SHOWS_SPORT"] = "ShowsSport";
    ECarouselSubCategory["SHOWS_EXHIBITIONS"] = "ShowsExhibitions";
    ECarouselSubCategory["SHOWS_PARTIES"] = "ShowsParties";
})(ECarouselSubCategory || (ECarouselSubCategory = {}));
export var EDealType;
(function (EDealType) {
    EDealType["Flights"] = "Flights";
    EDealType["Packages"] = "Packages";
    EDealType["OneWayBundle"] = "OneWayBundle";
    EDealType["Shows"] = "Shows";
    EDealType["Domestic"] = "Domestic";
})(EDealType || (EDealType = {}));
export var EFlightDealType;
(function (EFlightDealType) {
    EFlightDealType["RoundTrip"] = "RoundTrip";
    EFlightDealType["OneWay"] = "OneWay";
    EFlightDealType["FlightsToIsrael"] = "FlightsToIsrael";
    EFlightDealType["Carousel"] = "Carousel";
    EFlightDealType["OneWayBundle"] = "OneWayBundle";
    EFlightDealType["TishreiHolidaysFlights"] = "TishreiHolidaysFlights";
    EFlightDealType["ChristmasFlights"] = "ChristmasFlights";
    EFlightDealType["Packages"] = "Packages";
})(EFlightDealType || (EFlightDealType = {}));
export const FLIGHT_TYPE_SLUG_MAP = {
    [EFlightDealType.RoundTrip]: 'round-trip',
    [EFlightDealType.OneWayBundle]: 'open-jaw',
    [EFlightDealType.OneWay]: 'one-way',
    [EFlightDealType.FlightsToIsrael]: 'flights-to-israel',
    [EFlightDealType.TishreiHolidaysFlights]: 'tishrei-holidays-flights',
    [EFlightDealType.ChristmasFlights]: 'christmas-flights',
};
export var EPackageDealType;
(function (EPackageDealType) {
    EPackageDealType["Package"] = "Package";
    EPackageDealType["Cruise"] = "Cruise";
    EPackageDealType["OrganizedTour"] = "OrganizedTour";
    EPackageDealType["Ski"] = "Ski";
    EPackageDealType["Event"] = "Event";
    EPackageDealType["Spa"] = "Spa";
    EPackageDealType["FLT+HTL+CAR"] = "FLT+HTL+CAR";
    EPackageDealType["Sport"] = "Sport";
    EPackageDealType["Kosher"] = "Kosher";
    EPackageDealType["SummerDeals"] = "SummerDeals";
    EPackageDealType["WaterParks"] = "WaterParks";
    EPackageDealType["TishreiHolidays"] = "TishreiHolidays";
    EPackageDealType["Christmas"] = "Christmas";
    EPackageDealType["Sylvester"] = "Sylvester";
})(EPackageDealType || (EPackageDealType = {}));
export var EDomesticDealType;
(function (EDomesticDealType) {
    EDomesticDealType["Regular"] = "Regular";
    EDomesticDealType["SpaPackage"] = "SpaPackage";
    EDomesticDealType["ShowsPackage"] = "ShowsPackage";
    EDomesticDealType["KosherPackage"] = "KosherPackage";
    EDomesticDealType["FamilyPackage"] = "FamilyPackage";
    EDomesticDealType["IndependenceDay"] = "IndependenceDay";
    EDomesticDealType["Shavuot"] = "Shavuot";
    EDomesticDealType["TuBav"] = "TuBav";
    EDomesticDealType["TishreiHolidays"] = "TishreiHolidays";
    EDomesticDealType["Hanukkah"] = "Hanukkah";
})(EDomesticDealType || (EDomesticDealType = {}));
export var EShowDealType;
(function (EShowDealType) {
    EShowDealType["TuBav"] = "tu-bav";
})(EShowDealType || (EShowDealType = {}));
export const PACKAGE_TYPE_SLUG_MAP = {
    [EPackageDealType.Ski]: 'ski',
    [EPackageDealType.Event]: 'shows',
    [EPackageDealType.Sport]: 'sport',
    [EPackageDealType.Kosher]: 'kosher',
    [EPackageDealType.OrganizedTour]: 'org',
    [EPackageDealType.Cruise]: 'cruise',
    [EPackageDealType.SummerDeals]: 'summer-deals',
    [EPackageDealType['FLT+HTL+CAR']]: 'village-car',
    [EPackageDealType.WaterParks]: 'water-parks',
    [EPackageDealType.TishreiHolidays]: 'tishrei-holidays',
    [EPackageDealType.Christmas]: 'christmas',
    [EPackageDealType.Sylvester]: 'sylvester',
};
export var EFrontendDealType;
(function (EFrontendDealType) {
    EFrontendDealType["RoundTripToOneWayBundle"] = "RoundTripToOneWayBundle";
    EFrontendDealType["OneWayBundleToRoundTrip"] = "OneWayBundleToRoundTrip";
})(EFrontendDealType || (EFrontendDealType = {}));
export const BASE_PRODUCT_CODE_KEY = 'baseProductCode';
export var EShowCatalogContentType;
(function (EShowCatalogContentType) {
    EShowCatalogContentType["Regular"] = "Regular";
    EShowCatalogContentType["Carousel"] = "Carousel";
})(EShowCatalogContentType || (EShowCatalogContentType = {}));
export var ECommissionType;
(function (ECommissionType) {
    ECommissionType["FIX"] = "FIX";
    ECommissionType["PERCENTAGE"] = "PERCENTAGE";
})(ECommissionType || (ECommissionType = {}));
export var ESearchType;
(function (ESearchType) {
    ESearchType["Flights"] = "Flights";
    ESearchType["Packages"] = "Packages";
    ESearchType["Shows"] = "Shows";
    ESearchType["Domestic"] = "Domestic";
})(ESearchType || (ESearchType = {}));
export var EAsyncOperationStatus;
(function (EAsyncOperationStatus) {
    EAsyncOperationStatus["SUCCESS"] = "SUCCESS";
    EAsyncOperationStatus["FAILED"] = "FAILED";
    EAsyncOperationStatus["STARTED"] = "STARTED";
    EAsyncOperationStatus["IN_PROCESS"] = "IN-PROCESS";
})(EAsyncOperationStatus || (EAsyncOperationStatus = {}));
export const ASYNC_OPERATION_ACTIVE_STATUSES = [
    EAsyncOperationStatus.STARTED,
    EAsyncOperationStatus.IN_PROCESS,
];
export var EAsyncOperationType;
(function (EAsyncOperationType) {
    EAsyncOperationType["SyncFlights"] = "SyncFlights";
    EAsyncOperationType["SyncHotels"] = "SyncHotels";
    EAsyncOperationType["SyncShows"] = "SyncShows";
    EAsyncOperationType["SyncPackages"] = "SyncPackages";
    EAsyncOperationType["SearchFlights"] = "SearchFlights";
    EAsyncOperationType["SearchHotels"] = "SearchHotels";
    EAsyncOperationType["SearchPackages"] = "SearchPackages";
    EAsyncOperationType["ImportFlights"] = "ImportFlights";
    EAsyncOperationType["ImportPackages"] = "ImportPackages";
    EAsyncOperationType["ImportHotels"] = "ImportHotels";
    EAsyncOperationType["ImportSelfService"] = "ImportSelfService";
    EAsyncOperationType["PublishFlights"] = "PublishFlights";
    EAsyncOperationType["PublishFlightsCarousel"] = "PublishFlightsCarousel";
    EAsyncOperationType["PublishDomestic"] = "PublishDomestic";
    EAsyncOperationType["PublishDomesticCarousel"] = "PublishDomesticCarousel";
    EAsyncOperationType["PublishShows"] = "PublishShows";
    EAsyncOperationType["PublishShowsCarousel"] = "PublishShowsCarousel";
    EAsyncOperationType["HotelMappingReport"] = "HotelMappingReport";
})(EAsyncOperationType || (EAsyncOperationType = {}));
export var EAsyncOperationSource;
(function (EAsyncOperationSource) {
    EAsyncOperationSource["Cron"] = "cron";
    EAsyncOperationSource["Api"] = "api";
    EAsyncOperationSource["Console"] = "console";
})(EAsyncOperationSource || (EAsyncOperationSource = {}));
export var ESearchStatus;
(function (ESearchStatus) {
    ESearchStatus["SUCCESS"] = "SUCCESS";
    ESearchStatus["FAILED"] = "FAILED";
    ESearchStatus["NOT_PROCESS"] = "NOT-PROCESS";
    ESearchStatus["IN_PROCESS"] = "IN-PROCESS";
})(ESearchStatus || (ESearchStatus = {}));
export var ESkyScannerSearchInputSegmentType;
(function (ESkyScannerSearchInputSegmentType) {
    ESkyScannerSearchInputSegmentType["CITY"] = "city";
    ESkyScannerSearchInputSegmentType["AIRPORT"] = "airport";
})(ESkyScannerSearchInputSegmentType || (ESkyScannerSearchInputSegmentType = {}));
export var ECurrency;
(function (ECurrency) {
    ECurrency["USD"] = "USD";
    ECurrency["EUR"] = "EUR";
    ECurrency["ILS"] = "ILS";
    ECurrency["NIS"] = "NIS";
})(ECurrency || (ECurrency = {}));
export var EPassengerBOType;
(function (EPassengerBOType) {
    EPassengerBOType["ADULT"] = "ADULT";
    EPassengerBOType["INFANT"] = "INFANT";
})(EPassengerBOType || (EPassengerBOType = {}));
export var EPaymentStatus;
(function (EPaymentStatus) {
    EPaymentStatus["IN_PROCESS"] = "in_process";
    EPaymentStatus["FAILED"] = "failed";
    EPaymentStatus["SUCCESS"] = "success";
})(EPaymentStatus || (EPaymentStatus = {}));
export var EReserveStatus;
(function (EReserveStatus) {
    EReserveStatus["NOT_PROCESS"] = "not_process";
    EReserveStatus["SUCCESS"] = "success";
    EReserveStatus["FAILED"] = "failed";
    EReserveStatus["NEED_CONFIRMATION"] = "need_confirmation";
})(EReserveStatus || (EReserveStatus = {}));
export var EPassengerType;
(function (EPassengerType) {
    EPassengerType["ADULT"] = "adult";
    EPassengerType["SENIOR"] = "senior";
    EPassengerType["CHILD"] = "child";
    EPassengerType["INFANT"] = "infant";
})(EPassengerType || (EPassengerType = {}));
export var EOrderProcessStatus;
(function (EOrderProcessStatus) {
    EOrderProcessStatus["NOT_PROCESS"] = "not_process";
    EOrderProcessStatus["IN_PROCESS"] = "in_process";
    EOrderProcessStatus["END_PROCESS"] = "end_process";
})(EOrderProcessStatus || (EOrderProcessStatus = {}));
export var ECurrencySymbol;
(function (ECurrencySymbol) {
    ECurrencySymbol["NIS"] = "\u20AA";
    ECurrencySymbol["ILS"] = "\u20AA";
    ECurrencySymbol["USD"] = "$";
    ECurrencySymbol["EUR"] = "\u20AC";
})(ECurrencySymbol || (ECurrencySymbol = {}));
export var EHotelCatalogContentType;
(function (EHotelCatalogContentType) {
    EHotelCatalogContentType["RegularV2"] = "RegularV2";
    EHotelCatalogContentType["Carousel"] = "Carousel";
})(EHotelCatalogContentType || (EHotelCatalogContentType = {}));
export const HOTEL_TYPE_SLUG_MAP = {
    [EDomesticDealType.Regular]: 'regular',
    [EDomesticDealType.SpaPackage]: 'spa-package',
    [EDomesticDealType.ShowsPackage]: 'shows',
    [EDomesticDealType.KosherPackage]: 'kosher',
    [EDomesticDealType.FamilyPackage]: 'family',
    [EDomesticDealType.IndependenceDay]: 'independence-day',
    [EDomesticDealType.Shavuot]: 'shavuot',
    [EDomesticDealType.TuBav]: 'tu-bav',
    [EDomesticDealType.TishreiHolidays]: 'tishrei-holidays',
    [EDomesticDealType.Hanukkah]: 'hanukkah',
};
export var EBoPax;
(function (EBoPax) {
    EBoPax[EBoPax["1A"] = 1] = "1A";
    EBoPax[EBoPax["1A1C1I"] = 24] = "1A1C1I";
    EBoPax[EBoPax["2A"] = 2] = "2A";
    EBoPax[EBoPax["2C"] = 5] = "2C";
    EBoPax[EBoPax["2A1C"] = 7] = "2A1C";
    EBoPax[EBoPax["2A1C1I"] = 7] = "2A1C1I";
    EBoPax[EBoPax["2A2C"] = 8] = "2A2C";
    EBoPax[EBoPax["2A3C"] = 9] = "2A3C";
    EBoPax[EBoPax["2A4C"] = 14] = "2A4C";
    EBoPax[EBoPax["3A"] = 3] = "3A";
    EBoPax[EBoPax["3C"] = 6] = "3C";
    EBoPax[EBoPax["3A1C"] = 13] = "3A1C";
    EBoPax[EBoPax["3A2C"] = 11] = "3A2C";
    EBoPax[EBoPax["3A3C"] = 16] = "3A3C";
    EBoPax[EBoPax["4A"] = 12] = "4A";
    EBoPax[EBoPax["5A"] = 18] = "5A";
})(EBoPax || (EBoPax = {}));
export const CURRENCY_SYMBOLS = {
    [ECurrency.USD]: '$',
    [ECurrency.EUR]: '€',
    [ECurrency.ILS]: '₪',
    [ECurrency.NIS]: '₪',
};
export var EManagedError;
(function (EManagedError) {
    EManagedError["GENERAL_ERROR"] = "ORDER_GENERAL_ERROR";
    EManagedError["INTERNAL_ERROR"] = "INTERNAL_ERROR";
    EManagedError["USER_JOURNEY_TYPE_NOT_DEFINED"] = "USER_JOURNEY_TYPE_NOT_DEFINED";
    EManagedError["CATEGORY_TYPE_NOT_DEFINED"] = "CATEGORY_TYPE_NOT_DEFINED";
    EManagedError["RESPONSE_IS_EMPTY"] = "RESPONSE_IS_EMPTY";
    EManagedError["REQUEST_BODY_IS_EMPTY"] = "REQUEST_BODY_IS_EMPTY";
    EManagedError["REQUEST_QUERY_IS_EMPTY"] = "REQUEST_QUERY_IS_EMPTY";
    EManagedError["EXTERNAL_REQUEST_GET_ERROR"] = "EXTERNAL_REQUEST_GET_ERROR";
    EManagedError["NO_CONFIG_FLOW_FOUND"] = "NO_CONFIG_FLOW_FOUND";
    EManagedError["REQUEST_BODY_SCHEMA_ERROR"] = "REQUEST_BODY_SCHEMA_ERROR";
    EManagedError["PRODUCT_NOT_FOUND"] = "PRODUCT_NOT_FOUND";
    EManagedError["PRODUCT_NOT_ACTIVE"] = "PRODUCT_NOT_ACTIVE";
    EManagedError["ORDER_NOT_FOUND"] = "ORDER_NOT_FOUND";
    EManagedError["USER_NOT_FOUND"] = "USER_NOT_FOUND";
    EManagedError["INVALID_USER_PASSWORD"] = "INVALID_USER_PASSWORD";
    EManagedError["WRONG_RESET_PASSWORD_HASH"] = "WRONG_RESET_PASSWORD_HASH";
    EManagedError["PAYMENT_DETAILS_ERROR"] = "PAYMENT_DETAILS_ERROR";
    EManagedError["ORDER_HANDLE_ERROR_NOT_DEFINED"] = "ORDER_HANDLE_ERROR_NOT_DEFINED";
    EManagedError["DB_REQUEST_ERROR"] = "DB_REQUEST_ERROR";
    EManagedError["DUPLICATE_SUPPLIER"] = "DUPLICATE_SUPPLIER";
    EManagedError["LUGGAGE_PRICE_CHANGE"] = "LUGGAGE_PRICE_CHANGE";
    EManagedError["UNAVAILABLE_LUGGAGE"] = "UNAVAILABLE_LUGGAGE";
    EManagedError["ORDER_DETAILS_ERROR"] = "ORDER_DETAILS_ERROR";
    EManagedError["NO_PRODUCTS_FOUND"] = "NO_PRODUCTS_FOUND";
    EManagedError["DUPLICATE_ORDER"] = "DUPLICATE_ORDER";
    EManagedError["ORDER_PRICE_UPDATED"] = "ORDER_PRICE_UPDATED";
    EManagedError["ORDER_GENERAL_ERROR"] = "ORDER_GENERAL_ERROR";
    EManagedError["ORDER_PRICE_ZERO"] = "ORDER_PRICE_ZERO";
    EManagedError["NO_PASSENGERS"] = "NO_PASSENGERS";
    EManagedError["PAYER_DETAILS_IS_MISSING"] = "PAYER_DETAILS_IS_MISSING";
    EManagedError["RESERVED_ORDER_FAILED"] = "RESERVED_ORDER_FAILED";
    EManagedError["OUT_OF_HOUR"] = "OUT_OF_HOUR";
    EManagedError["OUT_OF_OPERATION_HOURS"] = "OUT_OF_OPERATION_HOURS";
    EManagedError["PAYMENTS_NOT_ALLOWED"] = "PAYMENTS_NOT_ALLOWED";
    EManagedError["INFANT_BIRTHDAY_ERROR"] = "INFANT_BIRTHDAY_ERROR";
    EManagedError["UNAVAILABLE_SEATS_COUNT"] = "UNAVAILABLE_SEATS_COUNT";
    EManagedError["ITEMS_COPY_ERROR"] = "ITEMS_COPY_ERROR";
    EManagedError["ITEMS_STATUS_ERROR"] = "ITEMS_STATUS_ERROR";
    EManagedError["RESPONSE_BODY_EMPTY"] = "RESPONSE_BODY_EMPTY";
    EManagedError["REQUEST_PARAM_MISSING"] = "REQUEST_PARAM_MISSING";
    EManagedError["INVALID_AUTHORIZATION_HEADER"] = "INVALID_AUTHORIZATION_HEADER";
    EManagedError["PRODUCT_NOT_COMPLETED"] = "PRODUCT_NOT_COMPLETED";
    EManagedError["NOT_PERMITTED"] = "NOT_PERMITTED";
    EManagedError["DISCOUNT_RATE_UNBAILABLE"] = "DISCOUNT_RATE_UNBAILABLE";
    EManagedError["NO_TICKETS"] = "NO_TICKETS";
    EManagedError["FORGET_PASSWORD_REQUIRED"] = "FORGET_PASSWORD_REQUIRED";
    EManagedError["OPERATION_IS_STILL_IN_PROGRESS"] = "OPERATION_IS_STILL_IN_PROGRESS";
    EManagedError["PAX_FILE_CREATE_ERROR"] = "PAX_FILE_CREATE_ERROR";
    EManagedError["USER_DISABLED"] = "USER_DISABLED";
    EManagedError["USER_CREATION_FAILED"] = "USER_CREATION_FAILED";
    EManagedError["USER_ALREADY_EXISTS"] = "USER_ALREADY_EXISTS";
    EManagedError["SUPPLIER_ALREADY_EXISTS"] = "SUPPLIER_ALREADY_EXISTS";
    EManagedError["UPDATE_FAILED"] = "UPDATE_FAILED";
    EManagedError["ADULT_COUNT_ERROR"] = "ADULT_COUNT_ERROR";
    EManagedError["MISSING_COUPON_NAME"] = "MISSING_COUPON_NAME";
    EManagedError["COUPON_DATA_NOT_VALID"] = "COUPON_DATA_NOT_VALID";
    EManagedError["COUPON_NOT_VALID"] = "COUPON_NOT_VALID";
    EManagedError["COUPON_EXPIRED"] = "COUPON_EXPIRED";
    EManagedError["COUPON_NOT_VALID_WITHOUT_CHARGE"] = "COUPON_NOT_VALID_WITHOUT_CHARGE";
    EManagedError["COUPON_NOT_VALID_WITH_CHARGE"] = "COUPON_NOT_VALID_WITH_CHARGE";
    EManagedError["COUPON_NOT_FOUND"] = "COUPON_NOT_FOUND";
    EManagedError["COUPON_LIMIT_EXCEEDED"] = "COUPON_LIMIT_EXCEEDED";
    EManagedError["COUPON_COVER_TOTAL_PRICE"] = "COUPON_COVER_TOTAL_PRICE";
    EManagedError["COUPON_PLATFORM_NOT_ALLOWED"] = "COUPON_PLATFORM_NOT_ALLOWED";
    EManagedError["COUPON_MINIMUM_REQUIRED"] = "COUPON_MINIMUM_REQUIRED";
    EManagedError["COUPON_MODULE_NOT_ALLOWED"] = "COUPON_MODULE_NOT_ALLOWED";
    EManagedError["COUPON_DESTINATION_NOT_ALLOWED"] = "COUPON_DESTINATION_NOT_ALLOWED";
    EManagedError["COUPON_CATEGORY_NOT_ALLOWED"] = "COUPON_CATEGORY_NOT_ALLOWED";
    EManagedError["COUPON_SHOW_NAME_NOT_ALLOWED"] = "COUPON_SHOW_NAME_NOT_ALLOWED";
    EManagedError["COUPON_HOTEL_NAME_NOT_ALLOWED"] = "COUPON_HOTEL_NAME_NOT_ALLOWED";
    EManagedError["VENUE_NAME_ALREADY_EXISTS"] = "VENUE_NAME_ALREADY_EXISTS";
    EManagedError["COMMENT_NOT_FOUND"] = "COMMENT_NOT_FOUND";
    EManagedError["POPUP_NOT_FOUND"] = "POPUP_NOT_FOUND";
    EManagedError["MARKETING_BANNER_NOT_FOUND"] = "MARKETING_BANNER_NOT_FOUND";
    EManagedError["MARKETING_BANNER_DUPLICATE_INTERNAL_NAME"] = "MARKETING_BANNER_DUPLICATE_INTERNAL_NAME";
    EManagedError["MARKETING_BANNER_DUPLICATE_SLUG"] = "MARKETING_BANNER_DUPLICATE_SLUG";
    EManagedError["COMMENT_CATEGORY_NOT_FOUND"] = "COMMENT_CATEGORY_NOT_FOUND";
    EManagedError["COMMENT_CATEGORY_ALREADY_EXISTS"] = "COMMENT_CATEGORY_ALREADY_EXISTS";
    EManagedError["COMMENT_CATEGORY_MODULE_MISMATCH"] = "COMMENT_CATEGORY_MODULE_MISMATCH";
    EManagedError["ANCILLARY_SERVICE_DUPLICATE"] = "ANCILLARY_SERVICE_DUPLICATE";
    EManagedError["JULYO_PRICING_RULE_DUPLICATE"] = "JULYO_PRICING_RULE_DUPLICATE";
    EManagedError["JULYO_PRICING_RULE_INVALID_TIERS"] = "JULYO_PRICING_RULE_INVALID_TIERS";
    EManagedError["PUBLISHING_RULE_NOT_FOUND"] = "PUBLISHING_RULE_NOT_FOUND";
})(EManagedError || (EManagedError = {}));
export var EPlatform;
(function (EPlatform) {
    EPlatform["android"] = "android";
    EPlatform["ios"] = "ios";
    EPlatform["web"] = "web";
})(EPlatform || (EPlatform = {}));
export var EDeviceType;
(function (EDeviceType) {
    EDeviceType["Desktop"] = "desktop";
    EDeviceType["Mobile"] = "mobile";
})(EDeviceType || (EDeviceType = {}));
export var EAvailablePlatform;
(function (EAvailablePlatform) {
    EAvailablePlatform["All"] = "all";
    EAvailablePlatform["Website"] = "website";
    EAvailablePlatform["MobileApp"] = "mobile-app";
})(EAvailablePlatform || (EAvailablePlatform = {}));
export var EProductTypeFE;
(function (EProductTypeFE) {
    EProductTypeFE["FLIGHT"] = "FLIGHT";
    EProductTypeFE["PACKAGE"] = "PACKAGE";
})(EProductTypeFE || (EProductTypeFE = {}));
export var ECustomerRemarkOption;
(function (ECustomerRemarkOption) {
    ECustomerRemarkOption["HallMarked"] = "HallMarked";
    ECustomerRemarkOption["HallArrivalOrder"] = "HallArrivalOrder";
    ECustomerRemarkOption["StandingShow"] = "StandingShow";
    ECustomerRemarkOption["StageMarked"] = "StageMarked";
    ECustomerRemarkOption["StageArrivalOrder"] = "StageArrivalOrder";
    ECustomerRemarkOption["DigitalTickets"] = "DigitalTickets";
    ECustomerRemarkOption["RandomSeat"] = "RandomSeat";
})(ECustomerRemarkOption || (ECustomerRemarkOption = {}));
export var EMeasurement;
(function (EMeasurement) {
    EMeasurement["impressionsConfirmationPage"] = "impressionsConfirmationPage";
    EMeasurement["submitOrderClick"] = "submitOrderClick";
})(EMeasurement || (EMeasurement = {}));
export const AffiliateCodes = {
    ClickOn: 'clickon',
};
export var ExternalReservationAgents;
(function (ExternalReservationAgents) {
    ExternalReservationAgents["Travelist"] = "travelist";
})(ExternalReservationAgents || (ExternalReservationAgents = {}));
export var EBoardBase;
(function (EBoardBase) {
    EBoardBase["AI"] = "AI";
    EBoardBase["BB"] = "BB";
    EBoardBase["HB"] = "HB";
    EBoardBase["FB"] = "FB";
    EBoardBase["RO"] = "RO";
    EBoardBase["UA"] = "UA";
})(EBoardBase || (EBoardBase = {}));
export var EShowItemCategory;
(function (EShowItemCategory) {
    EShowItemCategory["MUSIC"] = "\u05DE\u05D5\u05D6\u05D9\u05E7\u05D4";
    EShowItemCategory["THEATER"] = "\u05EA\u05D0\u05D8\u05E8\u05D5\u05DF";
    EShowItemCategory["DANCE"] = "\u05DE\u05D7\u05D5\u05DC";
    EShowItemCategory["SPORT"] = "\u05E1\u05E4\u05D5\u05E8\u05D8";
    EShowItemCategory["EXHIBITIONS"] = "\u05EA\u05E2\u05E8\u05D5\u05DB\u05D5\u05EA";
    EShowItemCategory["MOVIE"] = "\u05E7\u05D5\u05DC\u05E0\u05D5\u05E2";
    EShowItemCategory["LECTURES"] = "\u05D4\u05E8\u05E6\u05D0\u05D5\u05EA";
    EShowItemCategory["STANDUP"] = "\u05E1\u05D8\u05E0\u05D3-\u05D0\u05E4";
    EShowItemCategory["KIDS"] = "\u05D9\u05DC\u05D3\u05D9\u05DD";
    EShowItemCategory["PARTIES"] = "\u05DE\u05E1\u05D9\u05D1\u05D5\u05EA";
})(EShowItemCategory || (EShowItemCategory = {}));
export const SHOW_TYPE_SLUG_MAP = {
    [EShowItemCategory.KIDS]: 'kids',
    [EShowItemCategory.MUSIC]: 'music',
    [EShowItemCategory.DANCE]: 'dance',
    [EShowItemCategory.STANDUP]: 'standup',
    [EShowItemCategory.THEATER]: 'theater',
    [EShowItemCategory.EXHIBITIONS]: 'exhibitions',
    [EShowItemCategory.SPORT]: 'sport',
    [EShowItemCategory.MOVIE]: 'cinema',
    [EShowItemCategory.LECTURES]: 'lectures',
    [EShowItemCategory.PARTIES]: 'parties',
};
export var ECouponType;
(function (ECouponType) {
    ECouponType["Regular"] = "Regular";
    ECouponType["Multiple"] = "Multiple";
})(ECouponType || (ECouponType = {}));
export var ECouponAmountType;
(function (ECouponAmountType) {
    ECouponAmountType["Percent"] = "Percent";
    ECouponAmountType["Fix"] = "Fix";
})(ECouponAmountType || (ECouponAmountType = {}));
export var EPopupDisplayFrequency;
(function (EPopupDisplayFrequency) {
    EPopupDisplayFrequency["ONCE_ONLY"] = "once_only";
    EPopupDisplayFrequency["ONCE_PER_SESSION"] = "once_per_session";
    EPopupDisplayFrequency["EVERY_PAGE_VISIT"] = "every_page_visit";
})(EPopupDisplayFrequency || (EPopupDisplayFrequency = {}));
export var EPopupButtonAction;
(function (EPopupButtonAction) {
    EPopupButtonAction["CLOSE_ONLY"] = "close_only";
    EPopupButtonAction["INTERNAL_LINK"] = "internal_link";
    EPopupButtonAction["EXTERNAL_LINK"] = "external_link";
})(EPopupButtonAction || (EPopupButtonAction = {}));
export var EPopupIcon;
(function (EPopupIcon) {
    EPopupIcon["NONE"] = "none";
    EPopupIcon["ALERT"] = "alert";
    EPopupIcon["INFO"] = "info";
    EPopupIcon["CHECK"] = "check";
    EPopupIcon["GIFT"] = "gift";
    EPopupIcon["BELL"] = "bell";
    EPopupIcon["STAR"] = "star";
    EPopupIcon["HEART"] = "heart";
    EPopupIcon["ZAP"] = "zap";
    EPopupIcon["TRENDING"] = "trending";
    EPopupIcon["AWARD"] = "award";
    EPopupIcon["TARGET"] = "target";
    EPopupIcon["SPARKLES"] = "sparkles";
    EPopupIcon["MESSAGE"] = "message";
    EPopupIcon["MAIL"] = "mail";
    EPopupIcon["PHONE"] = "phone";
    EPopupIcon["CART"] = "cart";
    EPopupIcon["CARD"] = "card";
    EPopupIcon["TRUCK"] = "truck";
    EPopupIcon["PACKAGE"] = "package";
    EPopupIcon["CALENDAR"] = "calendar";
    EPopupIcon["CLOCK"] = "clock";
    EPopupIcon["WARNING"] = "warning";
    EPopupIcon["HELP"] = "help";
})(EPopupIcon || (EPopupIcon = {}));
export var ECampaignType;
(function (ECampaignType) {
    ECampaignType["POPUP"] = "popup";
    ECampaignType["GREETING_BAR"] = "greetingBar";
    ECampaignType["SLIDE_IN"] = "slideIn";
})(ECampaignType || (ECampaignType = {}));
export var ECampaignPosition;
(function (ECampaignPosition) {
    ECampaignPosition["TOP"] = "top";
    ECampaignPosition["BOTTOM"] = "bottom";
    ECampaignPosition["BOTTOM_LEFT"] = "bottom-left";
    ECampaignPosition["BOTTOM_RIGHT"] = "bottom-right";
})(ECampaignPosition || (ECampaignPosition = {}));
export var EPopupStatus;
(function (EPopupStatus) {
    EPopupStatus["ACTIVE"] = "active";
    EPopupStatus["INACTIVE"] = "inactive";
    EPopupStatus["ARCHIVED"] = "archived";
})(EPopupStatus || (EPopupStatus = {}));
export var EServiceType;
(function (EServiceType) {
    EServiceType["Baggage"] = "Baggage";
})(EServiceType || (EServiceType = {}));
export const EServiceSubType = {
    trolley: 'Trolley',
    baggage: 'Checked baggage (hold suitcase)',
};
export var EDistributionChannel;
(function (EDistributionChannel) {
    EDistributionChannel["HulyoDirect"] = "hulyo_direct";
    EDistributionChannel["Travelist"] = "travelist";
})(EDistributionChannel || (EDistributionChannel = {}));
export var EPriceType;
(function (EPriceType) {
    EPriceType["Fix"] = "Fix";
    EPriceType["Percentage"] = "%";
})(EPriceType || (EPriceType = {}));
export var EAncillaryServiceStatus;
(function (EAncillaryServiceStatus) {
    EAncillaryServiceStatus["Active"] = "active";
    EAncillaryServiceStatus["Inactive"] = "inactive";
    EAncillaryServiceStatus["Archived"] = "archived";
})(EAncillaryServiceStatus || (EAncillaryServiceStatus = {}));
export const ANCILLARY_SERVICE_RULE_ALL = 'All';
export var EPublishingRuleType;
(function (EPublishingRuleType) {
    EPublishingRuleType["PackageClusterCheapest"] = "PackageClusterCheapest";
})(EPublishingRuleType || (EPublishingRuleType = {}));
export var EPublishingRuleStatus;
(function (EPublishingRuleStatus) {
    EPublishingRuleStatus["Active"] = "active";
    EPublishingRuleStatus["Inactive"] = "inactive";
    EPublishingRuleStatus["Archived"] = "archived";
})(EPublishingRuleStatus || (EPublishingRuleStatus = {}));
export var EJulyoStatus;
(function (EJulyoStatus) {
    EJulyoStatus["Active"] = "active";
    EJulyoStatus["Inactive"] = "inactive";
    EJulyoStatus["Archived"] = "archived";
})(EJulyoStatus || (EJulyoStatus = {}));
//# sourceMappingURL=interfaces.js.map